import { render, staticRenderFns } from "./FormAddAddonToOrder.vue?vue&type=template&id=8d6694cc&"
import script from "./FormAddAddonToOrder.vue?vue&type=script&lang=js&"
export * from "./FormAddAddonToOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports